import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MessageLayout from "@/modules/messages/MessageLayout.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'StagedLicenseNotFoundError',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MessageLayout, {
    image: "./aws-token-expired.svg",
    title: "Trial license not found"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode(" Trial license not found. Please check the link or token and try again. ")
    ])),
    _: 1,
    __: [0]
  }))
}
}

})